<button [style]="styles">
    {{ buttonStyleTypeTranslations[button.styleType] | translate }}
</button>
